import { useTranslation } from "react-i18next";
import "./LoadingScreen.css";

/**
 * Full-viewport loading overlay: frosted glass panel, CSS spinner, indeterminate progress bar.
 */
export default function LoadingScreen() {
  const { t } = useTranslation();
  const label = String(t("common.loading", { defaultValue: "Loading" }));

  return (
    <div
      className="loader-container loading-screen-overlay"
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label={label}
    >
      <div className="loading-screen-panel">
        <div className="loading-screen-panel-inner">
          <div className="loading-screen-spin" aria-hidden />
          <div className="loading-screen-copy">
            <p className="loading-screen-title">
              {t("common.loading", { defaultValue: "Loading..." })}
            </p>
            <p className="loading-screen-sub">
              {t("common.loadingPleaseWait", { defaultValue: "Please wait" })}
            </p>
            <div className="loading-screen-progress" aria-hidden>
              <div className="loading-screen-progress-bar" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
